import { Box, BoxProps } from '@material-ui/core';
import React from 'react';

interface FlexColumnProps extends BoxProps {
  children: React.ReactNode | React.ReactNode[];
}

export const FlexColumn = ({ children, ...props }: FlexColumnProps) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      alignItems={'flex-start'}
      gridGap={8}
      {...props}
    >
      {children}
    </Box>
  );
};
